import { createDraftJobPost } from './CreateDraftJobPost';
import { createOnsiteInterviews } from './CreateOnsiteInterviews';
import { createShortlistCandidate } from './CreateShortlistCandidate';
import { deleteDraftJob } from './DeleteDraftJob';
import { deleteShortlistCandidate } from './DeleteShortlistCandidate';
import { getCandidateList } from './GetCandidateList';
import { getDraftJobPost } from './GetDraftJobPost';
import { getJobPostDetail } from './GetJobPostDetail';
import { getJobPostings } from './GetJobPostings';
import { getOnsiteInterviewList } from './GetOnsiteInterviewList';
import { getOnsiteInterviewStatusCount } from './GetOnsiteInterviewStatusCount';
import { publishDraftJobPost } from './PublishDraftJobPost';
import { saveJobPostDetail } from './SaveJobPostDetail';
import { updateCandidateStatus } from './UpdateCandidateStatus';

export const PermanentJobsService = {
  createDraftJobPost,
  createOnsiteInterviews,
  createShortlistCandidate,
  deleteDraftJob,
  deleteShortlistCandidate,
  getCandidateList,
  getDraftJobPost,
  getJobPostDetail,
  getJobPostings,
  getOnsiteInterviewList,
  getOnsiteInterviewStatusCount,
  publishDraftJobPost,
  saveJobPostDetail,
  updateCandidateStatus,
};
